import { Location } from "@angular/common";
import { AfterViewInit, Component, ContentChildren, QueryList, ViewChildren } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SubSink } from "subsink";
import { TabContext } from "../tab-context";
import { TabComponent } from "../tab/tab.component";

@Component({
    selector: 'tyt-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    providers: [TabContext]
})
export class TabsComponent {
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private location: Location
    ) {
    }

    subsink = new SubSink();
    private routeSelectedTabID: string;

    ngOnInit() {
        this.subsink.add(this.route.queryParamMap.subscribe(qp => {
            this.routeSelectedTabID = qp.get('t');
            this.updateSelectedTab();
        }));
    }

    ngAfterViewInit() {
        setTimeout(() => this.updateSelectedTab());
    }

    updateSelectedTab() {
        if (!this.tabs)
            return;

        let tab = this.tabs.find(x => x.id === this.routeSelectedTabID);
        if (!tab) {
            tab = this.tabs.first;
            this.routeSelectedTabID = tab.id;
        }
        this.setSelected(tab);
    }

    ngOnDestroy() {
        this.subsink.unsubscribe();
    }

    @ContentChildren(TabComponent, { descendants: true })
    tabs: QueryList<TabComponent>;

    get visibleTabs() {
        if (!this.tabs)
            return [];

        return this.tabs.toArray().filter(x => x.visible);
    }

    select(tab: TabComponent) {
        this.router.navigate([], {
            queryParams: { t: tab.id },
            queryParamsHandling: 'merge',
            replaceUrl: true
        });
    }

    private setSelected(tab: TabComponent) {
        if (this.tabs)
            this.tabs.forEach(x => x.unselect());
        if (tab)
            tab.select();
    }

    get selectedTab() {
        return this.routeSelectedTabID;
    }
}
